/* RFO full-carton system: sq-ft calculator + PER-LINE 500-sq-ft minimum. */
(function () {
  var EPS = 1e-9;
  var MIN_SQFT = 500; /* per-line minimum coverage */

  /* ---------------- Product-page calculator ---------------- */
  var SqftCalculator = function () { return Reflect.construct(HTMLElement, [], SqftCalculator); };
  SqftCalculator.prototype = Object.create(HTMLElement.prototype);
  SqftCalculator.prototype.constructor = SqftCalculator;

  SqftCalculator.prototype.connectedCallback = function () {
    this.per = parseFloat(this.dataset.sqftPerCarton);
    this.priceCents = parseInt(this.dataset.cartonPriceCents, 10);
    this.minOrder = parseFloat(this.dataset.minOrderSqft || '0');
    this.sym = this.dataset.currencySymbol || '$';
    this.input = this.querySelector('.js-sqft-input');
    this.summary = this.querySelector('.sqft-calculator__summary');
    this.msg = this.querySelector('.js-msg');
    this.qtyInput = this.querySelector('.js-carton-qty');
    this.propReq = this.querySelector('.js-prop-requested');
    this.propCov = this.querySelector('.js-prop-coverage');
    this.propPer = this.querySelector('.js-prop-percarton');

    var formId = this.qtyInput && this.qtyInput.getAttribute('form');
    this.form = (formId && document.getElementById(formId)) || this.closest('form');

    this.submitBtn = null;
    var pf = this.closest('product-form');
    if (pf) this.submitBtn = pf.querySelector('button[name="add"]');
    if (!this.submitBtn && this.form) this.submitBtn = this.form.querySelector('button[name="add"]');

    if (!this.per || isNaN(this.per) || this.per <= 0) { this.hardDisable(); return; }

    this.minCartons = Math.ceil((this.minOrder > 0 ? this.minOrder : 0) / this.per - EPS);
    this.setInvalid('');
    var self = this;
    this.input.addEventListener('input', function () { self.recalc(); });

    if (this.form) {
      this.form.addEventListener('submit', function (e) {
        /* Invalid / empty entry: block. */
        if (self.qtyInput.disabled || !(parseInt(self.qtyInput.value, 10) > 0)) {
          e.preventDefault(); e.stopImmediatePropagation();
          self.showMsg('Please enter the square footage you need before adding to cart.');
          self.input.focus();
          return;
        }
        /* Second pass (our own re-trigger): let the theme handle the add normally. */
        if (self._rfReplacing) { self._rfReplacing = false; return; }
        /* First pass: remove any existing line for this product, then re-add (Replace behaviour). */
        e.preventDefault(); e.stopImmediatePropagation();
        var variantId = self.getVariantId();
        self.removeExistingLine(variantId).then(function () {
          self._rfReplacing = true;
          if (self.submitBtn) { self.submitBtn.disabled = false; self.submitBtn.click(); }
          else if (self.form.requestSubmit) { self.form.requestSubmit(); }
          else { self.form.submit(); }
        });
      }, true);
    }
  };

  SqftCalculator.prototype.getVariantId = function () {
    var el = this.form.querySelector('.product-variant-id') || this.form.querySelector('[name="id"]');
    return el ? el.value : null;
  };

  SqftCalculator.prototype.removeExistingLine = function (variantId) {
    if (!variantId) return Promise.resolve();
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = {}; var found = false;
        (cart.items || []).forEach(function (it) {
          if (String(it.variant_id) === String(variantId)) { updates[it.key] = 0; found = true; }
        });
        if (!found) return;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
      })
      .catch(function () { /* if lookup fails, fall through and just add */ });
  };

  SqftCalculator.prototype.money = function (cents) {
    return this.sym + (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  SqftCalculator.prototype.recalc = function () {
    var req = parseFloat(this.input.value);
    if (!req || req <= 0) { this.setInvalid(''); return; }

    var cartons = Math.ceil(req / this.per - EPS);
    var coverage = Math.round(cartons * this.per * 100) / 100;
    var total = cartons * this.priceCents;

    this.q('.js-persqft').textContent = this.money(this.priceCents / this.per) + ' / sq ft';
    this.q('.js-requested').textContent = req.toLocaleString(undefined, { maximumFractionDigits: 2 }) + ' sq ft';
    this.q('.js-cartons').textContent = cartons + (cartons === 1 ? ' carton' : ' cartons');
    this.q('.js-coverage').textContent = coverage.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' sq ft';
    this.q('.js-total').textContent = this.money(total);
    this.summary.hidden = false;

    this.qtyInput.value = cartons; this.qtyInput.disabled = false;
    this.propReq.value = req; this.propReq.disabled = false;
    this.propCov.value = coverage.toFixed(2); this.propCov.disabled = false;
    this.propPer.disabled = false;

    /* Per-line rule: this product's coverage must reach the minimum. Block if short. */
    if (this.minOrder > 0 && coverage + 1e-6 < this.minOrder) {
      if (this.submitBtn) this.submitBtn.disabled = true;
      this.showMsg('Minimum order for this product is ' + this.minOrder + ' sq ft (' + this.minCartons +
        ' cartons). Please enter at least ' + this.minOrder + ' sq ft.');
    } else {
      if (this.submitBtn) this.submitBtn.disabled = false;
      this.hideMsg();
    }
  };

  SqftCalculator.prototype.setInvalid = function (text) {
    if (this.summary) this.summary.hidden = true;
    if (this.qtyInput) { this.qtyInput.value = ''; this.qtyInput.disabled = true; }
    [this.propReq, this.propCov, this.propPer].forEach(function (i) { if (i) i.disabled = true; });
    if (this.submitBtn) this.submitBtn.disabled = true;
    if (text) { this.showMsg(text); } else { this.hideMsg(); }
  };

  SqftCalculator.prototype.hardDisable = function () {
    this.setInvalid('Square-footage data is missing for this product. Please contact us to order.');
    if (this.input) this.input.disabled = true;
  };

  SqftCalculator.prototype.showMsg = function (t) { this.msg.textContent = t; this.msg.hidden = false; };
  SqftCalculator.prototype.hideMsg = function () { this.msg.hidden = true; this.msg.textContent = ''; };
  SqftCalculator.prototype.q = function (s) { return this.querySelector(s); };

  if (!customElements.get('sqft-calculator')) customElements.define('sqft-calculator', SqftCalculator);

  /* Sticky-bar button scrolls to the main calculator */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.js-scroll-to-calculator');
    if (!btn) return;
    var calc = document.querySelector('sqft-calculator');
    if (calc) {
      calc.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var i = calc.querySelector('.js-sqft-input');
      if (i) setTimeout(function () { i.focus(); }, 400);
    }
  });

  /* ---------------- Cart: PER-LINE 500 sq ft minimum ---------------- */
  function checkoutButtons() {
    return document.querySelectorAll('#checkout, button[name="checkout"], .btn-checkout');
  }

  function validateCartPerLine() {
    var inputs = document.querySelectorAll('input[name="updates[]"][data-rf-sqft-per-carton]');
    var shortNames = [];
    inputs.forEach(function (inp) {
      var per = parseFloat(inp.getAttribute('data-rf-sqft-per-carton'));
      if (!per || per <= 0) return; /* non-flooring line: ignore */
      var qty = parseInt(inp.value || '0', 10);
      var coverage = qty * per;
      if (coverage + 1e-6 < MIN_SQFT) {
        var name = inp.getAttribute('data-rf-title') || 'a flooring item';
        if (shortNames.indexOf(name) === -1) shortNames.push(name);
      }
    });
    var invalid = shortNames.length > 0;

    checkoutButtons().forEach(function (b) {
      b.disabled = invalid;
      b.classList.toggle('is-disabled-minsqft', invalid);
    });
    document.querySelectorAll('.js-min-sqft-msg').forEach(function (m) {
      if (invalid) {
        m.hidden = false;
        m.textContent = 'Each flooring product must be at least ' + MIN_SQFT + ' sq ft. Please increase: ' + shortNames.join(', ') + '.';
      } else {
        m.hidden = true; m.textContent = '';
      }
    });
  }

  document.addEventListener('DOMContentLoaded', validateCartPerLine);

  /* Theme pub/sub (global.js): re-validate after AJAX cart updates.
     Two passes beat any late re-enable by the theme after its own re-render. */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      setTimeout(validateCartPerLine, 60);
      setTimeout(validateCartPerLine, 350);
    });
  }

  /* Catch every way a cart quantity can change: typing, change event, and +/- stepper clicks. */
  ['input', 'change'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      if (e.target && e.target.matches && e.target.matches('input[name="updates[]"]')) {
        setTimeout(validateCartPerLine, 30);
      }
    });
  });
  document.addEventListener('click', function (e) {
    var stepper = e.target.closest && e.target.closest('quantity-input button, .quantity__button');
    if (stepper) { setTimeout(validateCartPerLine, 250); setTimeout(validateCartPerLine, 600); }
  });

  /* Fallback: any DOM re-render of the cart contents re-runs the check. */
  var t;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(validateCartPerLine, 150); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
